/**
 * @param {unknown[]} records
 * @param {((record: unknown) => string) | undefined}keyGetter
 * @returns {Promise<Array<[string, unknown[]]>>}
 */
export default async function groupRecordsByPinyin(records, keyGetter) {
  const pinyinjs = (await import("thepinyin.js")).default;
  const groups = {};
  for (const record of records) {
    const key = keyGetter ? keyGetter(record) : record;
    let [firstPinyin] = pinyinjs.py(key[0] ?? "", pinyinjs.NOMARK);
    if (Array.isArray(firstPinyin)) {
      firstPinyin = firstPinyin[0];
    }
    let firstAlpha = (
      firstPinyin ? firstPinyin[0] : key[0] ?? ""
    ).toLowerCase();
    if (!/[a-z]/.test(firstAlpha)) {
      firstAlpha = "#";
    }
    if (!groups[firstAlpha]) {
      groups[firstAlpha] = [];
    }
    groups[firstAlpha].push(record);
  }
  return [
    ...Object.entries(groups).sort(([a], [b]) => (a > b ? 1 : a < b ? -1 : 0)),
  ];
}
